import { Injectable, OnDestroy } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';
import { Account } from '../interfaces/account';
import { AccountService } from '../services/account.service';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class CanActivateExternalSettingsGuard implements CanActivate, OnDestroy {
  private externalRole: boolean = false;

  private destroyed$: Subject<void> = new Subject<void>();

  constructor(
    private readonly accountService: AccountService,
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {
    this.authService.externalRole$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((externalRole: boolean) => (this.externalRole = externalRole));
  }

  canActivate(): Promise<boolean | UrlTree> {
    return new Promise<boolean | UrlTree>((resolve) => {
      this.accountService.selectedAccount
        .pipe(
          filter((account) => !!account),
          take(1),
        )
        .subscribe((selectedAccount) =>
          resolve(this.externalRole ? true : this.router.navigate(['/dashboard', (selectedAccount as Account).uid])),
        );
    });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
